<template>
    <v-dialog
      v-model="dialog"
      width="900"    
      persistent
    >              
    <!-- Form Start -->
    <v-card :color="formdata.color">
        <!-- Form Caption -->        
        <v-card-title v-if="formdata.name != ''">           
            <h1 class="display-2">{{formdata.name}}</h1> </br>
            <!--<code>{{entities}}</code> -->
            <!--<code>{{recipesteps}}</code> -->
        </v-card-title>
        <!-- Main Container-->
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <!-- First Box/ Save Box -->                  
                <component :is="formsave" :helptext="formdata.helptext" :dialogmode="true" v-on:submitted="onSubmitted"></component>  
                <v-flex d-flex xs12>
                    <v-layout row wrap>  
                        <!-- Main Form Block -->
                        <keep-alive>
                            <component :is="formblock"
                                        :color="formdata.mainblock.blocks[0].color"
                                        :title="formdata.mainblock.blocks[0].title"
                                        :blockcomponents="formdata.mainblock.blocks[0].blockcomponents"  
                                        :vuexnamespace="formdata.vuexnamespace"
                            ></component>
                        </keep-alive>                           
                    </v-layout>
                </v-flex>
                              
            </v-layout>
        </v-container>
    <!-- Form End -->
    </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters } from 'vuex';
    import formblock from "./FormFormBlock.vue"
    import formsave from "./FormSave.vue"
    export default { 
    name: "mainform",
    components: {
        formblock:"formblock",
        formsave:"formsave"
    },
    props:[
        'formdata',  
        'dialog',
        'itemid'
        
    ],
    data() {
        return {                   
            formblock:formblock,
            formsave:formsave,
            
        }
    },
   computed: {
       
        result () {
            return this.$store.getters[this.formdata.vuexnamespace+'/dataobject']
        },
        parent_id() {
            return this.$route.params.id
        },
        entities() {
            return this.$store.getters['entities/entities']                    
        },
        recipesteps(){
            return this.$store.getters['recipesteps/recipesteps']
        }
        
    },
    watch:{
        //result(){alert ('watched')}
    },
    methods: {
        onSubmitted(submitted){                 
            if(submitted) {                  
                this.$store.dispatch(this.formdata.vuexnamespace+'/postForm',{payload:this.result,id:this.itemid, parent_id:this.parent_id})
                    .then(response=>{        
                        this.setMessage(response.status,"Erfolg! Dateneingabe erfolgreich!")
                    }).catch(error => {                    
                    this.setMessage(error.response.status,error.response.data.errors)                    
                    return 
                })                                
            } 
            
            this.$emit("dialogtoggled")
        },
        async init(){    
            await this.$store.dispatch(this.formdata.vuexnamespace + '/getAll')
            this.$store.commit(this.formdata.initmutation)
            if(this.itemid != null && typeof this.itemid != "undefined") {
                await this.$store.dispatch(this.formdata.vuexnamespace + '/getById',this.itemid)            
            }
        }
    },    
    mounted(){        
       this.init() 
    },

   
                 
        
}
</script>